import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Beautiful%20anime%20style%20illustration%20with%20cherry%20blossom%20petals%20floating%20in%20a%20dreamy%20pink%20sky%2C%20soft%20warm%20sunset%20gradient%2C%20magical%20sparkles%2C%20silhouette%20of%20anime%20characters%20in%20distance%2C%20ethereal%20atmosphere%2C%20romantic%20and%20mysterious%2C%20high%20quality%20illustration%2C%20anime%20art%20background&width=1920&height=900&seq=hero-bg-anime&orientation=landscape"
        alt="羞羞动漫网站 - 动漫美女爆羞羞动漫在线蜜桃"
        title="羞羞动漫网站 | 51动漫国产精品入口"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center px-4 w-full max-w-3xl">
          <h1 className="font-heading text-3xl md:text-5xl text-white mb-4 leading-tight">
            羞羞动漫网站
          </h1>
          <p className="text-base md:text-lg text-white/90 mb-3 max-w-xl mx-auto leading-relaxed">
            动漫美女爆羞羞动漫在线蜜桃 · 51动漫国产精品入口
          </p>
          <p className="text-sm text-white/70 mb-6 max-w-lg mx-auto leading-relaxed">
            汇集精品动漫推荐与动漫美女角色，免费在线看蜜桃动漫大全
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/mitao"
              className="px-6 py-2.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line mr-1.5"></i>蜜桃动漫专区
            </Link>
            <Link
              to="/category/guochan"
              className="px-6 py-2.5 bg-white/20 backdrop-blur-sm text-white border border-white/30 rounded-full text-sm font-medium hover:bg-white/30 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-fire-line mr-1.5"></i>国产精品推荐
            </Link>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}